import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KTypeParameterClass;
function KTypeParameter() {
  if (KTypeParameterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KTypeParameter');
    KTypeParameterClass = $;
  }
  return KTypeParameterClass;
}
//region block: exports
export {
  KTypeParameter as KTypeParameter1s8efufd4mbj5,
};
//endregion

//# sourceMappingURL=KTypeParameter.mjs.map
